export default {
  全部交易产品: "取引商品一覧はこちら",
};
